/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CheckStateRequest
 */
export interface CheckStateRequest {
  /**
   *
   * @type {string}
   * @memberof CheckStateRequest
   */
  companyId: string;
}

/**
 * Check if a given object implements the CheckStateRequest interface.
 */
export function instanceOfCheckStateRequest(
  value: object,
): value is CheckStateRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  return true;
}

export function CheckStateRequestFromJSON(json: any): CheckStateRequest {
  return CheckStateRequestFromJSONTyped(json, false);
}

export function CheckStateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CheckStateRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
  };
}

export function CheckStateRequestToJSON(json: any): CheckStateRequest {
  return CheckStateRequestToJSONTyped(json, false);
}

export function CheckStateRequestToJSONTyped(
  value?: CheckStateRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
  };
}
